export { PriceSliderFacet } from './PriceSliderFacet'
export type { PriceSliderFacetProps } from './PriceSliderFacet'
